import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatOption } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { GraphService } from 'src/app/services/graph.service';
import { LoaderService } from 'src/app/services/loader.service';
import { PoOrderDataServiceService } from 'src/app/services/po-order-data-service.service';
import { UserService } from 'src/app/services/user.service';
import { ApproveDialogComponent } from '../approve-dialog/approve-dialog.component';
import { DcnErrorComponent } from '../dcn-error/dcn-error.component';
import { AdvanceSearchDto } from '../model/advance-search-dto';
import { DcMaintainenceResponse } from '../model/dc-maintainence-response';
import { Roles } from '../model/roles';
import { SortableColumn } from '../model/sort/sortable-column';
import { UserData } from '../model/user-data';
import { UsersDataResponse } from '../model/users-data-response';
import { Usersearch } from '../model/usersearch';

@Component({
    selector: 'app-advance-search',
    templateUrl: './advance-search.component.html',
    styleUrls: ['./advance-search.component.scss'],
    standalone: false
})
export class AdvanceSearchComponent implements OnInit {

  user: UsersDataResponse;
  userData: UserData;
  advanceSearchForm: UntypedFormGroup;
  myControl = new UntypedFormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;
  storeTypeDisabled: boolean = false;
  poTypeDisabled: boolean = true;
  filteredUPN: Observable<Usersearch[]>;
  usersUpn: Usersearch[] = [];
  @ViewChild('select') select: MatSelect;
  @ViewChild("f") myForm; //used to reset validation
  textcomponent:boolean=false;
  message:string=null;
  constructor(private router: Router, private userservice: UserService, private fb: UntypedFormBuilder, private route: ActivatedRoute,
    private dialog: MatDialog, public dialogRef: MatDialogRef<AdvanceSearchComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    public translate: TranslateService,private poordersummaryservice:PoOrderDataServiceService,
    public loaderService: LoaderService,private dateAdapter: DateAdapter<Date>) {
    this.dialogRef.disableClose = true;
    this.loaderService.adshow();
    
    
   

    this.createForm();
    this.advanceSearchForm.controls.poNumber.disable();
    this.advanceSearchForm.controls.storeNumber.enable();
    this.advanceSearchForm.controls.poStatus.disable();
    this.advanceSearchForm.controls.signedBy.disable();
    this.advanceSearchForm.controls.fromDateCd.disable();
    this.advanceSearchForm.controls.toDateCd.disable();
    this.advanceSearchForm.controls.fromDateRc.disable();
    this.advanceSearchForm.controls.toDateRc.disable();
  
   


    this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
      this.options = this.user.stores?this.user.stores.map(value => (value.storeNumber)):null;
      this.translate.use(this.userData.language.toLowerCase());
       if (this.userData && this.userData.roleId>3 &&  this.user.stores.length===1) {
    this.advanceSearchForm.controls.storeNumber.setValue(this.user.stores[0].sdmStoreNumber);
    this.textcomponent=true;
    this.advanceSearchForm.controls.storeNumber.disable();
      this.onchangeStore();
     
      
     }
    
    
     this.dateAdapter.setLocale(this.userData.language.toLowerCase()); 

  })
}


  ngOnInit() {
    this.filteredOptions = this.advanceSearchForm.controls.storeNumber.valueChanges
      .pipe(
        startWith(''),
        map((value:string)=> this._filter(value))
      );
  

  }




  userView: UsersDataResponse;
  userDataView: UserData;




  createForm() {
    this.advanceSearchForm = this.fb.group({
      selectedSearchType: ['1', Validators.required],
      selectedReportType: ['3', Validators.required],
      storeNumber: [''],
      poNumber: [''],
      poStatus:[''],
      status: [''],
      signedBy: [''],
      fromDateCd: [''],
      toDateCd: [''],
      fromDateRc: [''],
      toDateRc: [''],


    });

  }






  private _filter(value: string): string[] {
    let filterValue = value !== null ? value.toLowerCase() : '';
    
    // if(filterValue && filterValue.length<6){
    //   filterValue=(this.padLeft(filterValue,'0',6));
    // }
    if(value?.charAt(0)==='0'){
      let options=this.options?this.options.filter(option => option.toLowerCase().startsWith(filterValue)):null; 
      options.sort((a,b) =>  (a > b ? 1 : -1));
      return options;

    }else{
      if(this.options){
       let options= this.options.filter(option => parseInt(option).toString().toLowerCase().startsWith(filterValue));
          options.sort((a,b) =>  (a > b ? 1 : -1));
      return options;
      return  
      }else{
        return null;
      }
     
    }
    let sno=parseInt(value);
   
  }

  private upn_filter(value: string): Usersearch[] {
    const filterValue = value !== null ? value.toLowerCase() : '';
    let upn:any=[];
    if(filterValue!==''){
    upn=this.usersUpn.filter(option => option.fullName.toLowerCase().startsWith(filterValue));
    }else{
      upn=this.usersUpn.filter(option => option);
    }
  upn.sort((a, b) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()))
    return upn;
  }

  close(): void {
    this.dialogRef.close("No");
  }

  onChangeBySearchType() {
    let selectedType = this.advanceSearchForm.controls.selectedSearchType.value;
    this.advanceSearchForm.controls.status.reset();
    this.advanceSearchForm.controls.poStatus.reset();
    this.select.options.forEach((item: MatOption) => item.deselect());
   
    if (selectedType === "1") {
      this.storeTypeDisabled = false;
      this.poTypeDisabled = true;
      this.advanceSearchForm.controls.poNumber.disable();
      this.advanceSearchForm.controls.poNumber.reset();
      this.advanceSearchForm.controls.storeNumber.enable();
      this.storeChangeDisable();
     

    } else {
      this.storeTypeDisabled = true;
      this.poTypeDisabled = false;
      this.advanceSearchForm.controls.poNumber.enable();
      this.advanceSearchForm.controls.storeNumber.disable();
      this.advanceSearchForm.controls.signedBy.disable();

      this.advanceSearchForm.controls.fromDateCd.disable();
      this.advanceSearchForm.controls.toDateCd.disable();
      this.advanceSearchForm.controls.fromDateRc.disable();
      this.advanceSearchForm.controls.toDateRc.disable();
      this.advanceSearchForm.controls.storeNumber.reset();
      this.advanceSearchForm.controls.signedBy.reset();
      this.advanceSearchForm.controls.fromDateCd.reset();
      this.advanceSearchForm.controls.toDateCd.reset();
      this.advanceSearchForm.controls.fromDateRc.reset();
      this.advanceSearchForm.controls.toDateRc.reset();
      this.advanceSearchForm.controls.selectedReportType.setValue("3");



    }

  }

 
  onchangeStore() {
    let storeNumber = this.advanceSearchForm.controls.storeNumber.value;
    this.storeChangeDisable();
    if (this.userData && this.userData.roleId>3 &&  this.user.stores.length===1) {
      this.advanceSearchForm.controls.storeNumber.setValue(this.user.stores[0].sdmStoreNumber);
      this.textcomponent=true;
      this.advanceSearchForm.controls.storeNumber.disable();
        
       
        
       }
    if (storeNumber !== undefined && storeNumber !== null) {
      storeNumber=(this.padLeft(storeNumber,'0',6));
      this.advanceSearchForm.controls.signedBy.reset();
      this.loaderService.load();
      this.userservice.getUsersByStoreAll(storeNumber).subscribe(data => {
        this.loaderService.unload();
       
        this.usersUpn = data.map(u => u);
        this.filteredUPN = this.advanceSearchForm.controls.signedBy.valueChanges
        .pipe(
          startWith(''),
          map((ev:string) => this.upn_filter(ev))
        );

      })

    }
  }

  storeChangeDisable(){
    let store= this.advanceSearchForm.controls.storeNumber.value;
    if(store === '' || store ===null || store ===undefined){
   
        console.log("store ===undefined>> " + store);
    this.advanceSearchForm.controls.poStatus.disable();
    this.advanceSearchForm.controls.signedBy.disable();
    this.advanceSearchForm.controls.fromDateCd.disable();
    this.advanceSearchForm.controls.toDateCd.disable();
    this.advanceSearchForm.controls.fromDateRc.disable();
    this.advanceSearchForm.controls.toDateRc.disable();
    }else{
      console.log("store ===" + store) ;
      this.advanceSearchForm.controls.storeNumber.enable();
     
      this.advanceSearchForm.controls.poStatus.enable();
      this.advanceSearchForm.controls.signedBy.enable();
      this.advanceSearchForm.controls.fromDateCd.enable();
      this.advanceSearchForm.controls.toDateCd.enable();
      this.advanceSearchForm.controls.fromDateRc.enable();
      this.advanceSearchForm.controls.toDateRc.enable();

      
    }
  }

  statusAll: any[] = [

    { value: '1', viewValue: 'Pending' },
    { value: '2', viewValue: 'Overdue' },
    { value: '3', viewValue: 'Late' },
    { value: '4', viewValue: 'Signed' },
    { value: '5', viewValue: 'Reported' }
  ];
  allSelected = false;
  toggleAllSelection() {
    if (this.advanceSearchForm.controls.status.value) {
      this.select.options.forEach((item: MatOption) => item.select());
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
  }
  optionClick() {
    let newStatus = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
        return;
      }
    });
    this.advanceSearchForm.controls.status.setValue(newStatus);
  
  }


  yes() {
    this.dialogRef.close("Yes");
  }

  no() {
    this.dialogRef.close("No");
  }

  search() {
    this.message=null;
    if (!this.advanceSearchForm.valid) {
      this.advanceSearchForm.invalid;
    } else {
      this.loaderService.load();
      let as=this.preparedAdvanceSearchInput();
      this.userservice.setObject('advancesearch',as );
     this.getPOOrderWithAdvanceSearch(as);

      
    }
  }

  padLeft(text:string, padChar:string, size:number): string {
    return (String(padChar).repeat(size) + text).substr( (size * -1), size) ;
  }
  preparedAdvanceSearchInput() {
    let ad = new AdvanceSearchDto();
    let sNo=this.advanceSearchForm.controls.storeNumber.value;
    if(sNo!='' && sNo!==null){
     if(sNo.length<6){
        sNo=(this.padLeft(sNo,'0',6));
      }  
    ad.storeNumber = sNo;
    }
    let pNo=this.advanceSearchForm.controls.poNumber.value;
    if(pNo!=''){
    ad.purchaseOrderNumber = pNo;
    }
    let sBy=this.advanceSearchForm.controls.signedBy.value;
   
    if(sBy!=''){
    ad.poSignedBy = sBy;
    }
    let fDateCD=this.advanceSearchForm.controls.fromDateCd.value;
    if(fDateCD!==null && fDateCD!==""){
    let fromDate = JSON.stringify(fDateCD)
    ad.poFromCreatedDate = fromDate.slice(1, 11);
    } 
    let tDateCD=this.advanceSearchForm.controls.toDateCd.value;
    if(tDateCD!==null && tDateCD!==""){
    let toDate = JSON.stringify(tDateCD)
    ad.poToCreatedDate = toDate.slice(1, 11);
    }
    let fDateRc=this.advanceSearchForm.controls.fromDateRc.value;
    if(fDateRc!==null && fDateRc!==""){
    let fromReceivedDate = JSON.stringify(fDateRc)
    ad.poFromReceivedDate = fromReceivedDate.slice(1, 11);
    }
    let tDateRc=this.advanceSearchForm.controls.toDateRc.value;
    if(tDateRc!==null  && tDateRc!==""){
    let toReceivedDate = JSON.stringify(tDateRc)
    ad.poToReceivedDate = toReceivedDate.slice(1, 11);
    }
    let stats=this.advanceSearchForm.controls.poStatus.value
    if(stats){    
    ad.poStatusArray = stats;
    ad.poStatus=ad.poStatusArray.toString();
    }
    let potype=this.advanceSearchForm.controls.selectedReportType.value;
    if(potype==="1"){
      ad.poType ='OC'
    }else
    if(potype==="2"){
      ad.poType= 'RC'
    }else{
      ad.poType=''
    }
     
    return ad;
  }
  poOrderChange() {
    let poordertype = this.advanceSearchForm.controls.selectedReportType.value;
    let selectSearchType = this.advanceSearchForm.controls.selectedSearchType.value;
    this.advanceSearchForm.controls.fromDateCd.reset();
    this.advanceSearchForm.controls.toDateCd.reset();
    this.advanceSearchForm.controls.fromDateRc.reset();
    this.advanceSearchForm.controls.toDateRc.reset();
   let sno= this.advanceSearchForm.controls.storeNumber.value;
    if (selectSearchType === "2") {
      this.advanceSearchForm.controls.fromDateCd.disable();
      this.advanceSearchForm.controls.toDateCd.disable();
      this.advanceSearchForm.controls.fromDateRc.disable();
      this.advanceSearchForm.controls.toDateRc.disable();
    } else

      if (poordertype === "2" || poordertype === "3") {
        this.advanceSearchForm.controls.fromDateCd.enable();
        this.advanceSearchForm.controls.toDateCd.enable();
        this.advanceSearchForm.controls.fromDateRc.enable();
        this.advanceSearchForm.controls.toDateRc.enable();
      } else {
        this.advanceSearchForm.controls.fromDateCd.enable();
        this.advanceSearchForm.controls.toDateCd.enable();
        this.advanceSearchForm.controls.fromDateRc.disable();
        this.advanceSearchForm.controls.toDateRc.disable();
      }
  }



  clear() {
this.advanceSearchForm.reset(); 
this.createForm();
this.select.options.forEach((item: MatOption) => item.deselect());
this.advanceSearchForm.controls.poNumber.disable();

this.advanceSearchForm.controls.storeNumber.enable();
setTimeout(() => {this.advanceSearchForm.controls.storeNumber.enable(); }, 1000);
if (this.userData && this.userData.roleId>3 &&  this.user.stores.length===1) {
  this.advanceSearchForm.controls.storeNumber.setValue(this.user.stores[0].sdmStoreNumber);
  this.textcomponent=true;
  this.advanceSearchForm.controls.storeNumber.disable();
  this.onchangeStore();     
   }
this.advanceSearchForm.controls.poStatus.disable();
this.advanceSearchForm.controls.signedBy.disable();
this.advanceSearchForm.controls.fromDateCd.disable();
this.advanceSearchForm.controls.toDateCd.disable();
this.advanceSearchForm.controls.fromDateRc.disable();
this.advanceSearchForm.controls.toDateRc.disable();
this.message=null;

   this.myForm.resetForm(); //to rest the validation
 // this.advanceSearchForm.reset(); // add this before createForm to work
  }
 

  getPOOrderWithAdvanceSearch(advanceSearch) {   
     
    advanceSearch.pageNo=0;
    advanceSearch.pageSize=15;
    advanceSearch.order= 'asc';
    advanceSearch.sort='';
      return this.poordersummaryservice!.advanceSearchMain(advanceSearch)
        .subscribe(data =>{
              
          if(data.content.length===0){
            // let dialogData= {
            //   title: this.userData.language==="EN"?'No Records Found':"Aucune transaction trouvée",
            //   message: this.userData.language==="EN"?"No records to display.":"Aucune transaction à afficher",
             
            // }
            this.message=this.userData.language==="EN"?'No Records Found':"Aucune transaction trouvée";
            // this.dialog.open(ApproveDialogComponent,{
            //   data:dialogData,panelClass: 'my-class'
            // });
            this.loaderService.unload();
          
          }else{
            this.dialogRef.close("Yes");
            this.loaderService.adhide();
            this.loaderService.unload();
          }
          console.log(data);
        });
         
    
  }


}
